module.exports = __webpack_public_path__ + "img/21.f809f787.png";